module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00072.5fbe1ed6.jpg";